import { render, staticRenderFns } from "./ColorPallet.vue?vue&type=template&id=531b5a00&scoped=true&"
import script from "./ColorPallet.vue?vue&type=script&lang=js&"
export * from "./ColorPallet.vue?vue&type=script&lang=js&"
import style0 from "./ColorPallet.vue?vue&type=style&index=0&id=531b5a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531b5a00",
  null
  
)

export default component.exports